import React from 'react';
import logo from '../../../../assets/image/header-logo.svg';
import styles from '../style/HeaderLogo.module.scss';

export default function HeaderLogo({
  onClick,
}: {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}) {
  return (
    <div
      onClick={onClick}
      aria-label='site logo'
      className={styles.logo}
      id='Header-Logo_Button'
      data-testid='Header-Logo_Button'
    >
      <img src={logo} alt={'dhi logo'} className={styles.img} />
      <div className={`${styles.logoTextContainer}`}>
        <h1>Metocean Data Portal</h1>
      </div>
    </div>
  );
}
